/**
 * Heavily inspired by JQuery Cookie
 *
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
export const setCookie = (key, value, options = {}) => {
    if (!value && String(value) !== '[object Object]') {
        throw new Error('Value is required');
    }

    if (value === null || value === undefined) {
        options.expires = -1;
    }

    if (typeof options.expires === 'number') {
        var days = options.expires,
            t = (options.expires = new Date());
        t.setDate(t.getDate() + days);
    }

    value = String(value);

    return (document.cookie = [
        encodeURIComponent(key),
        '=',
        options.raw ? value : encodeURIComponent(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '',
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : ''
    ].join(''));
};

export const getCookie = (key, options = {}) => {
    var result,
        decode = options.raw
            ? function(s) {
                  return s;
              }
            : decodeURIComponent;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie))
        ? decode(result[1])
        : null;
};

export const CHINA_MODE_COOKIE_KEY = 'chinaMode';
